<template>
  <div>
    <section class="promotion-page">
      <div v-if="!promotionPage" class="text-center mt-10">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <component
        v-else
        :is="module.componentType"
        v-for="(module, index) in promotionPage.modules"
        :key="index"
        v-bind="module"
        :promotionPage="promotionPage"
      ></component>
    </section>
  </div>
</template>
<script>

import promotionPages from '../data/promotion-pages';
import axios from 'axios';
import PromotionBanner from './PromotionBanner'
import PromotionCallToAction from './PromotionCallToAction'
import PromotionHeader from './PromotionHeader'
import PromotionInformation from './PromotionInformation'
import PromotionPricing from './PromotionPricing'
import PromotionVideo from './PromotionVideo'

const ActivationStatus = {
  NeverSubscribed: 0,
  InActivationProssess: 1,
  Subscribed: 2,
  UnSubscribedButNotStopped: 3,
  SubscriptionStopped: 4
}

export default {
  components: {
    PromotionBanner,
    PromotionCallToAction,
    PromotionHeader,
    PromotionInformation,
    PromotionPricing,
    PromotionVideo
  },
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: () => ({
    promotionPage: null,
    subscriptions: null
  }),
  computed: {
    addOn() {
      return this.promotionPage ? this.promotionPage.addOn : null
    }
  },
  methods: {
    mapModules(data) {
      let modules = []
      data.children.forEach(x => {
        let module = {
          componentType: x.contentType,
        }
        x.properties.forEach(y => {
          if (Array.isArray(y.content)) {
            let array = []
            y.content.forEach(c => {
              let property = {};
              c.properties.forEach(p => {
                property[p.propertyTypeAlias] = p.content
              })
              array.push(property)
            })
            y.content = array;
          }
          module[y.propertyTypeAlias] = y.content
        })
        modules.push(module)
      })
      return modules
    },
    getActivationStatusForAddon(addOnId) {
      if (window.CONFIG.departments.length === 1) {
        this.subscriptions = this.subscriptions.filter(s => s.SiteId === window.CONFIG.user.CurrentSiteId)
      }
      // There are more statuses, but for now try to keep it simple.
      // At least one active
      if (this.subscriptions.some(s => s.SubscriptionStatus === ActivationStatus.Subscribed)) {
        return ActivationStatus.Subscribed
      }
      // At least one activating
      if (this.subscriptions.some(s => s.SubscriptionStatus === ActivationStatus.InActivationProssess)) {
        return ActivationStatus.InActivationProssess
      }
      return ActivationStatus.NeverSubscribed
    },
    updateBreadcrumb() {
      if (this.addOn && this.$store && this.$store._mutations && this.$store._mutations['breadcrumbs/setItems']) {
        this.$store.commit('breadcrumbs/setItems', [{
          name: 'Innstillinger',
          page: 'home'
        }, {name: this.addOn.Description || 'Kom i gang'}])
      }
    }
  },
  async created() {
    let result = promotionPages.find(page => page.name === this.name)
    if (result) {
      let addOn
      let addOnSubscriptionPlans = []
      let addOnSubscriptions = []
      let activationStatus = ActivationStatus.NeverSubscribed
      if (result.addOnEnumTypeId) {
        let addOnEnumTypeId = result.addOnEnumTypeId
        let chainId = window.CONFIG.user.ChainId
        let response = await axios.post(`/api/ajax/AddOns/GetAddOnByEnumTypeId`, `=${addOnEnumTypeId}`)
        addOn = response.data
        if (addOn) {
          let addOnId = addOn.Id
          let response = await Promise.all([
            await axios.post(`/api/ajax/AddOns/GetAddOnSubscriptionPlans`, `=${addOnId}`),
            await axios.post(`/api/ajax/AddOns/GetAddOnSubscriptions`, {
              addOnId,
              chainId
            }),
          ])
          let plans = response[0].data.Array
          let subscriptions = response[1].data
          this.subscriptions = subscriptions.map(s => {
            s.AddOnId = addOnId
            return s
          })


          addOnSubscriptionPlans = Object.values(plans).filter(p => p.AddOnId === addOnId)
          addOnSubscriptions = subscriptions.filter(x => x.AddOnId === addOnId);
          activationStatus = this.getActivationStatusForAddon(addOnId)
        }
      }

      let responseModules = await axios.get(`${window.CONFIG.fixitCoreApiUrl}/api/Home/GetCmsDataByUrlPath`, {
        params: {
          url: window.location.href
        }
      })
      result.modules = this.mapModules(responseModules.data);
      // merge promotion page content/modules,add-on object, and subscription plans to one object
      this.promotionPage = Object.assign({}, result, {
        addOn,
        addOnSubscriptionPlans,
        addOnSubscriptions,
        activationStatus
      })
    }
    this.updateBreadcrumb()
  }
}
</script>
